import { render, staticRenderFns } from "./Not Found.vue?vue&type=template&id=af67cbaa&"
import script from "./Not Found.vue?vue&type=script&lang=js&"
export * from "./Not Found.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports